import React from 'react';

import Cards from '../Cards/Cards';
import Container from '../interface/Container';
import BlockWrapper from './BlockWrapper';

const CardsBlock = ({ block }) => (
  <BlockWrapper>
    <Container>
      <Cards cardsData={block} />
    </Container>
  </BlockWrapper>
);

export default CardsBlock;
